import React, { useContext } from 'react'
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';

function AddToCart({ name, productId, extraClasses, sellingPlanId=null }) {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);
    function disableButton() {
        return state.cart.extendedWarranty === productId || state.cart.kit?.productId === productId || (state.cart.filters.reduce((prev, curr) => prev || (curr.productId === productId  && curr.sellingPlanId === sellingPlanId), false))
    }
    function handleClick() {
        if (sellingPlanId) {
            dispatch({ type: 'updateCart', payload: { name: name, value: {productId, sellingPlanId} } })
        } else {
            dispatch({ type: 'updateCart', payload: { name: name, value: productId } })
        }
    }
    return (
        <button className={`bg-brio-300 disabled:bg-muted-200 rounded-lg font-bold py-2 px-3 text-base ${extraClasses}`} disabled={disableButton()} onClick={handleClick} type="button">Add To Cart</button>

    )
}

export default AddToCart